<app-pagetoolbar icon="local_hospital" label="Crossmatches"> </app-pagetoolbar>
<mat-card class="fab-panel" ngClass.xs="fab-panel-xs">
  <div class="filter-container">
    <mat-button-toggle-group [value]="selectedFilter" (change)="onFilterChange($event.value)" aria-label="Filter crossmatches">
      <mat-button-toggle value="current">Current</mat-button-toggle>
      <mat-button-toggle value="historical">Historical</mat-button-toggle>
      <mat-button-toggle value="all">All</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <button mat-fab color="accent" id="new-crossmatch" type="button" (click)="openAddDialog()" *ngIf="addCrossmatches">
    <mat-icon>add</mat-icon>
  </button>

  <mat-tab-group>
    <mat-tab label="Positive Crossmatches">
      <app-crossmatch-list [crossmatches]="filteredPositiveCrossmatches" [totalRows]="pcCount" type="Positive"> </app-crossmatch-list>
    </mat-tab>
    <mat-tab label="Negative Crossmatches">
      <app-crossmatch-list [crossmatches]="filteredNegativeCrossmatches" [totalRows]="ncCount" type="Negative"> </app-crossmatch-list>
    </mat-tab>
  </mat-tab-group>
</mat-card>
